import React, { PureComponent } from 'react';
import { func, bool, string } from 'prop-types';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTCheckbox from '../../../../components/UTCheckbox';
import { message } from '../../../../../utils/stringUtils';

import styles from './styles';

class TermsAndConditions extends PureComponent {
  render() {
    return (
      <div style={styles.form}>
        <div style={styles.termsContainer}>
          <div
            dangerouslySetInnerHTML={this.props.terms} // eslint-disable-line react/no-danger
            style={styles.terms}
          />
        </div>
        <UTCheckbox
          label={message('Signup:acceptTermsConditions')}
          onChange={this.props.handleCheckTerms}
          value={this.props.acceptedTerms}
        />
      </div>
    );
  }
}

TermsAndConditions.propTypes = {
  terms: string,
  handleCheckTerms: func.isRequired,
  acceptedTerms: bool.isRequired
};

export default WithLoading(props => props.loading)(Radium(TermsAndConditions));
